<mat-drawer-container autosize>
  <div id="contentContainer">
    <div id="scrollContainer">
      <mat-toolbar>
        <div class="toolbarContent">
          <span>Travel Time Graph</span>
          <span>
            <mat-icon (click)="drawer.toggle()">menu</mat-icon>
          </span>
        </div>
      </mat-toolbar>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>

      <app-locations-form (submit)="submit($event)"></app-locations-form>
      <br>
      <br>

      <mat-card *ngIf="loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </mat-card>

      <div *ngIf="travelInfos.length > 0 && !loading">
        <app-chart [travelInfos]="travelInfos"></app-chart>
      </div>
      <br>
      <br>
    </div>
  </div>


  <mat-drawer #drawer mode="push" position="end">
    <app-drawer></app-drawer>
  </mat-drawer>
</mat-drawer-container>



// WEBPACK FOOTER //
// /Users/cwseger/go/src/github.com/cwseger/travel-time-ui/src/app/app.component.html